
import { defineComponent, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { default as Model } from '../../models/proPostCategories.model';
import SubmitButton from '../../components/ui/SubmitButton.vue';
import FileUpload from '../../components/ui/FileUpload.vue';
import swal from '../../helper/swal.helper';

export default defineComponent({
  components: {
    SubmitButton,
    FileUpload,
  },
  setup() {
    const router = useRouter();
    let isSubmitting = ref(false);
    let loading = ref(true);
    let thumbnailFile = ref<any>(null);

    let categoryId = router.currentRoute.value.params.id;
    let category = ref({
      name: '',
      sub_name: '',
      event_key: '',
      status: false,
      thumbnail: '',
      order_number: 0,
    });
    let setPreviewImg = ref('');
    onMounted(async () => {
      category.value = await Model.findById(categoryId);
      setPreviewImg.value = category.value.thumbnail;
      loading.value = false;
    });

    async function submitForm() {
      isSubmitting.value = true;
      let thumbnail = await thumbnailFile.value?.uploadImage();
      if (thumbnail.length <= 0) {
        thumbnail = category.value.thumbnail;
      }

      let data = {
        name: category.value.name,
        sub_name: category.value.sub_name,
        event_key: category.value.event_key,
        status: category.value.status,
        thumbnail: thumbnail,
        order_number: category.value.order_number,
      };

      let addResult = await Model.update(categoryId, data);
      if (addResult.status) {
        isSubmitting.value = false;
        router.replace('/pro-post-categories');
      } else {
        swal.alert(addResult.message);
        isSubmitting.value = false;
      }
    }

    return {
      submitForm,
      isSubmitting,
      category,
      loading,
      thumbnailFile,
      setPreviewImg,
    };
  },
});
